import React from 'react';
import Logo from './Logo';
import Footer from './Footer';

export default function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 grid grid-cols-1 md:grid-cols-2">
        {/* Left visual — desktop only */}
        <div className="hidden md:flex bg-warm-teal m-6 rounded-3xl items-center justify-center p-12">
          <Logo size="xl" className="drop-shadow-xl" />
        </div>

        {/* Right: form column */}
        <div className="flex items-center justify-center p-6 sm:p-8 md:p-12 lg:p-16">
          <div className="w-full max-w-md">
            {/* Mobile logo (above form) */}
            <div className="mb-6 sm:mb-8 flex justify-center md:hidden">
              <Logo size="md" />
            </div>

            {title && (
              <h1 className="text-3xl sm:text-3xl font-bold text-gray-900 font-display mb-2">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-base text-gray-600 mb-6 sm:mb-8">{subtitle}</p>
            )}

            {children}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
